import { memo, useState } from 'react';
import './index.less';
import { EyeO, ClosedEye } from '@react-vant/icons';
import { Form, Field, Button, Toast } from 'react-vant';
import { history, Helmet, useModel } from '@umijs/max';
// import { queryLogin } from '@/service';
import { ToLogin } from '@/service/login';
import { queryAccountInfo } from '@/service/banner';
import { useLocalStorageState } from 'ahooks';

const Login = () => {
  const onTo = () => {
    history.push('/register');
  };
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [, setWechatInfo] = useLocalStorageState<any>('wechatInfo', {
    listenStorageChange: true,
  });
  // 记住上次登录的手机号，下次登录自动填充
  const [rememberPhone, setRememberPhone] = useLocalStorageState<string>(
    'rememberPhone',
  );
  const { queryInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      queryInformation: model.queryInformation,
      defaultRoom: model.defaultRoom,
      bindInformation: model.bindInformation,
    }),
  );


  // const queryInfo = () => {
  //   queryAccountInfo().then((res) => {
  //     setWechatInfo(res.data);
  //     history.replace('/');
  //   });
  // };

  const onFinish = (values: any) => {
    setLoading(true);

    ToLogin({ ...values, source: 'owner' })
      .then(async (res: any) => {
        if (res && res.code === 200) {
          Toast.success('登录成功！');

          window.localStorage.setItem('token', res.token);
          window.localStorage.setItem('loginInfo', JSON.stringify(values));
          // 记住本次登录的手机号，下次登录默认显示
          setRememberPhone(values.username);
          await queryInformation()
          history.replace('/');
          // history.replace('/')
          // queryInfo();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleForgotPassword = () => {
    history.push('/forgetPassword');
  };

  return (
    <div>
      <Helmet>
        <title>登录</title>
      </Helmet>

      <div className="login-container">
        <div className="login-header">
          <div className="logo">
            <h1>欢迎回来</h1>
            <p>请登录您的账户继续操作</p>
          </div>
        </div>

        <div className="login-form">
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={{
              username: rememberPhone || '',
              password: '',
            }}
          >
            <Form.Item
              name="username"
              label="手机号"
              rules={[
                { required: true, message: '请输入手机号' },
                {
                  pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                  message: '请输入正确的手机号码',
                },
              ]}
            >
              <Field placeholder="请输入手机号" clearable />
            </Form.Item>

            <Form.Item
              name="password"
              label="密码"
              rules={[
                { required: true, message: '请输入密码' },
                { min: 6, message: '密码至少6位' },
              ]}
            >
              <Field
                type={showPassword ? 'text' : 'password'}
                placeholder="请输入密码"
                rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
                onClickRightIcon={() => setShowPassword(!showPassword)}
              />
            </Form.Item>

            <div className="form-options">
              <div className="forgot-password" onClick={handleForgotPassword}>
                忘记密码?
              </div>
            </div>

            <div className="submit-btn">
              <Button
                round
                block
                type="primary"
                nativeType="submit"
                loading={loading}
                loadingText="登录中..."
              >
                登录
              </Button>
            </div>
          </Form>
        </div>

        <div className="login-footer">
          还没有账户?{' '}
          <span className="forgot-password" onClick={onTo}>
            立即注册
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(Login);
